/**
 * Copy all keys of obj that exist into that into that ;-)
 * @param dto
 * @param obj
 */
export default function assignToThis(that: any, obj: any) {
  Object.keys(that).forEach(key => {
    if (key in obj && obj[key] !== undefined) { // or obj1.hasOwnProperty(key)
      that[key] = obj[key];
    }
  });
}
